export function initializeHebrew (selector) {
    const hebrewTextContainers = document.querySelectorAll(selector)

    for (const container of hebrewTextContainers) {
        if (container.innerHTML.indexOf(">") > -1) {
            return
        }

        let words = (container.innerHTML.trim()).split(/\s+/)

        for (let i = 0; i < words.length; i++) {

            let wordParts = words[i].split("־") // <- there is a symbol

            if (wordParts.length > 1) {
                for (let j = 0; j < wordParts.length; j++) {
                    wordParts[j] = `<span class="hebrew-word" onclick="translateHebrew(this.innerHTML, 0)">${ wordParts[j] }</span>`
                }
                words[i] = wordParts.join("־")
            }
            else {

                let isRoot = container.hasAttribute("data-root")
                let id = container.getAttribute("data-id")
                let word = words[i]

                if (id) {
                    word = id
                }

                words[i] = `<span class="hebrew-word" onclick="translateHebrew('${ word }', ${ isRoot ? 1 : 0 })">${ words[i] }</span>`
            }
        }

        container.innerHTML = words.join(" ")
    }
}


export function checkAvailability (hebrewWordsSelector) {
    let words = []

    const hebrewWordElements = document.querySelectorAll(hebrewWordsSelector)

    for (const wordElement of hebrewWordElements) {
        let raw = wordElement.innerHTML.replace(/[\u0591-\u05C7]/g, '')
        
        wordElement.setAttribute("data-raw", raw)

        if (words.indexOf(raw) == -1) {
            words.push(raw)
        }
    }

    axios.post('/api/dictionary/check-availability', {
        _token: window.csrfToken,
        words: words.join(",")
    }).then(response => {
        words = response.data.split(",")

        for (const wordElement of hebrewWordElements) {
            if (words.indexOf(wordElement.getAttribute("data-raw")) == -1) {
                wordElement.onclick = null
                wordElement.className = "unknown-hebrew-word"
            }
        }
    })
}
